import { IonRouterOutlet } from '@ionic/react'
import React from 'react'
import { Route, RouteComponentProps } from 'react-router-dom'
import Contracts from './Contracts'
import Profile from './Profile'

const OnlineOrderRouter: React.FC<RouteComponentProps> = ({match}) => {
  return (
    <IonRouterOutlet>
      <Route path={`${match.url}/profile`} component={Profile} exact={true} />
      <Route path={`${match.url}/contracts`} component={Contracts} exact={true} />
      <Route path={`${match.url}`} render={() => <div>empty auth!</div>} exact={true} />
    </IonRouterOutlet>
  )
}

export default OnlineOrderRouter
